export const socialInformationArray = [
  {
    title: "Welcome to the world's only theme park dedicated to St. Bernards",
    description: "",
    awards: "",
    url: "https://www.instagram.com/p/DcCtnfaGtz0/?img_index=1",
    images: [
      {
        type: "image",
        src: "/projects/social/stbernard/stbernard-01.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/stbernard/stbernard-02.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/stbernard/stbernard-03.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/stbernard/stbernard-04.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/stbernard/stbernard-05.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/stbernard/stbernard-06.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/stbernard/stbernard-07.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/stbernard/stbernard-08.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/stbernard/stbernard-09.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/stbernard/stbernard-10.jpg",
        alt: "",
      },
    ],
  },
  {
    title: "These are the celebrity wines worth buying",
    description: "",
    awards: "",
    url: "https://www.instagram.com/p/DbTnMjVFG6A/?img_index=1",
    images: [
      {
        type: "image",
        src: "/projects/social/celebritywines/celebritywines_01.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/celebritywines/celebritywines_02.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/celebritywines/celebritywines_03.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/celebritywines/celebritywines_04.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/celebritywines/celebritywines_05.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/celebritywines/celebritywines_06.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/celebritywines/celebritywines_07.jpg",
        alt: "",
      },
    ],
  },
  {
    title:
      "Wish you had a robot to do your chores? Tech companies are paying people to show them how.",
    description: "",
    awards: "",
    url: "https://www.instagram.com/p/DXmWOjKlcGH/?img_index=1",
    images: [
      {
        type: "video",
        src: "/projects/social/robotlaundry/robotlaundry-1-sm.mp4",
        alt: "",
      },
      {
        type: "video",
        src: "/projects/social/robotlaundry/robotlaundry-2-sm.mp4",
        alt: "",
      },
      {
        type: "video",
        src: "/projects/social/robotlaundry/robotlaundry-3-sm.mp4",
        alt: "",
      },
      {
        type: "video",
        src: "/projects/social/robotlaundry/robotlaundry-4-sm.mp4",
        alt: "",
      },
      {
        type: "video",
        src: "/projects/social/robotlaundry/robotlaundry-5-sm.mp4",
        alt: "",
      },
    ],
  },
  {
    title:
      "Cocktail menus can be confusing. Here's how to choose a drink you'll love.",
    description: "",
    awards: "",
    url: "https://www.instagram.com/p/DZvW5kQlLzS/?img_index=1",
    images: [
      {
        type: "image",
        src: "/projects/social/spirits/spirits-1.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/spirits/spirits-2.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/spirits/spirits-3.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/spirits/spirits-4.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/spirits/spirits-5.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/spirits/spirits-6.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/spirits/spirits-7.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/spirits/spirits-8.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/spirits/spirits-9.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/spirits/spirits-10.jpg",
        alt: "",
      },
    ],
  },
  {
    title: "The game. The fits. The aura.",
    description: "",
    awards: "",
    url: "https://www.instagram.com/p/DYkFPNWj-L_/?img_index=1",
    images: [
      {
        type: "image",
        src: "/projects/social/NBA/nba_01.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/NBA/nba_02.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/NBA/nba_03.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/NBA/nba_04.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/NBA/nba_05.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/NBA/nba_06.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/NBA/nba_07.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/NBA/nba_08.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/NBA/nba_09.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/NBA/nba_10.jpg",
        alt: "",
      },
    ],
  },
  {
    title:
      "The Pentagon is releasing UFO files. These believers are glad it's finally coming around.",
    description: "",
    awards: "",
    url: "https://www.instagram.com/p/DZD-xYJnIa3/?img_index=1",
    images: [
      {
        type: "image",
        src: "/projects/social/ufo/ufo_01.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/ufo/ufo_02.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/ufo/ufo_03.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/ufo/ufo_04.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/ufo/ufo_05.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/ufo/ufo_06.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/ufo/ufo_07.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/ufo/ufo_08.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/ufo/ufo_09.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/ufo/ufo_10.jpg",
        alt: "",
      },
    ],
  },
  {
    title:
      "An accidental spoiler from host Jeff Probst turned the 'Survivor' finale into a train wreck.",
    description: "",
    awards: "",
    url: "https://www.instagram.com/p/DYnFuwelqCg/?img_index=1",
    images: [
      {
        type: "image",
        src: "/projects/social/survivor/survivor_01.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/survivor/survivor_02.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/survivor/survivor_03.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/survivor/survivor_04.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/survivor/survivor_05.jpg",
        alt: "",
      },
    ],
  },
  {
    title: "Pizza Hut is struggling. Can red-roof nostalgia help save it?",
    description: "",
    awards: "",
    url: "https://www.instagram.com/p/Dai1-M1FBKe/?img_index=1",
    images: [
      {
        type: "image",
        src: "/projects/social/pizzahut/PizzaHut_01.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/pizzahut/PizzaHut_02.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/pizzahut/PizzaHut_03.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/pizzahut/PizzaHut_04.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/pizzahut/PizzaHut_05.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/pizzahut/PizzaHut_06.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/pizzahut/PizzaHut_07.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/pizzahut/PizzaHut_08.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/pizzahut/PizzaHut_09.jpg",
        alt: "",
      },
      {
        type: "image",
        src: "/projects/social/pizzahut/PizzaHut_10.jpg",
        alt: "",
      },
    ],
  },
];
